<button
  type="button"
  class="btn"
  [class]="buttonType"
  [disabled]="buttonDisable || loading"
  [style.font-size]="fontSize || null"
  (click)="onClick()"
>
  <i
    class="fas {{ buttonIcon }}"
    *ngIf="buttonIcon"
    [style.font-size]="iconSize || fontSize || null"
  ></i>
  <i
    class="{{ buttonIconV6 }}"
    *ngIf="buttonIconV6"
    [style.font-size]="iconSize || fontSize || null"
  ></i>
  {{ buttonText | translate }}
  <span class="loader" *ngIf="loading"></span>
</button>
